var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPointsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 28,
    viewBox: "0 0 26 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M25.7998 11.2799V26.4799C25.7998 26.8319 25.5118 27.1199 25.1598 27.1199H1.47984C1.12784 27.1199 0.839844 26.8319 0.839844 26.4799V11.2799C0.839844 11.0239 0.967844 10.8319 1.19184 10.7039L2.75984 9.90388V13.9999C2.75984 14.1919 2.85584 14.3519 2.98384 14.4799L12.9038 22.7999C13.0318 22.8959 13.1598 22.9599 13.3198 22.9599C13.4798 22.9599 13.6078 22.8959 13.7358 22.7999L23.6558 14.4799C23.8158 14.3519 23.8798 14.1919 23.8798 13.9999V9.87188L25.4478 10.6719C25.6718 10.7999 25.7998 11.0239 25.7998 11.2799ZM13.3198 21.4879L4.03984 13.7119V1.51988C4.03984 1.16788 4.32784 0.879883 4.67984 0.879883H21.9598C22.3118 0.879883 22.5998 1.16788 22.5998 1.51988V13.7119L13.3198 21.4879ZM15.5598 5.35988C15.5598 5.71188 15.8478 5.99988 16.1998 5.99988H17.4798V7.27988C17.4798 7.63188 17.7678 7.91988 18.1198 7.91988C18.4718 7.91988 18.7598 7.63188 18.7598 7.27988V5.99988H20.0398C20.3918 5.99988 20.6798 5.71188 20.6798 5.35988C20.6798 5.00788 20.3918 4.71988 20.0398 4.71988H18.7598V3.43988C18.7598 3.08788 18.4718 2.79988 18.1198 2.79988C17.7678 2.79988 17.4798 3.08788 17.4798 3.43988V4.71988H16.1998C15.8478 4.71988 15.5598 5.00788 15.5598 5.35988Z",
    fill: "url(#paint0_linear_641_89)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_641_89",
    x1: 13.3198,
    y1: 0.879883,
    x2: 13.3198,
    y2: 27.1199,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4056DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3746A3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPointsIcon);
export default __webpack_public_path__ + "static/media/pointsIcon.ee79ac78b8a68bd366abea93c3c92d35.svg";
export { ForwardRef as ReactComponent };